import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { APP_INITIALIZER, inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TitleStrategy } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AnalyticsBootstrapService } from './core/analytics-bootstrap.service';
import { AnalyticsInterceptor } from './core/interceptors/analytics.interceptor';
import { CsrfInterceptor } from './core/interceptors/csrf.interceptor';
import { TermsRequiredInterceptor } from './core/interceptors/terms-required.interceptor';
import { PageTitleStrategy } from './core/page-title.strategy';
import { AppConfigService } from './core/services/app-config.service';
import { StaleBuildRecoveryService } from './core/stale-build-recovery.service';

@NgModule({
  imports: [BrowserModule, BrowserAnimationsModule, AppRoutingModule],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: CsrfInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AnalyticsInterceptor, multi: true },
    // Not signed in until the T&C are accepted: any TERMS_REQUIRED answer signs out.
    { provide: HTTP_INTERCEPTORS, useClass: TermsRequiredInterceptor, multi: true },
    { provide: TitleStrategy, useClass: PageTitleStrategy },
    // Resolved before the first route activates, so route guards have a
    // definite answer rather than racing the request.
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (config: AppConfigService) => () => config.load(),
    },
    // Subscribes to the router before its first navigation, so the landing
    // page view is not missed. Fetches nothing until something is tracked.
    provideAppInitializer(() => inject(AnalyticsBootstrapService).start()),
    // Also before the first navigation: Back after a deploy lands on exactly
    // that navigation, with an old build asking for files that are gone.
    provideAppInitializer(() => inject(StaleBuildRecoveryService).start()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
